export function normalizeRouterBasePath(value: string | undefined): string {
  const trimmed = value?.trim();

  if (!trimmed || trimmed === '/') {
    return '/';
  }

  const withoutTrailingSlash = trimmed.replace(/\/+$/u, '');
  return withoutTrailingSlash.startsWith('/')
    ? withoutTrailingSlash
    : `/${withoutTrailingSlash}`;
}

export const ROUTER_BASE_PATH = normalizeRouterBasePath(
  import.meta.env.VITE_ROUTER_BASE_PATH,
);
